'use client';

import { useMemo } from 'react';
import useSWR from 'swr';
import { getDilutingSymbols } from '@/lib/api-client';

/**
 * Shared set of symbols with a recent (≤30d) SEC dilutive offering filing.
 *
 * SWR dedupes by key, so every movers row / watchlist tile can call this and
 * only ONE network request fires per refresh window. Returns a Set for O(1)
 * `.has(symbol)` checks at render time; memoized so the reference is stable
 * while the underlying data is unchanged.
 */
export function useDilutingSymbols(): Set<string> {
  const { data } = useSWR('offerings/diluting-symbols', getDilutingSymbols, {
    revalidateOnFocus: false,
    dedupingInterval: 5 * 60_000,
    refreshInterval: 10 * 60_000,
  });
  return useMemo(() => new Set(data ?? []), [data]);
}
